export default __webpack_public_path__ + "static/media/cloud.84377027.svg";